"use client";
import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { patientDetailsQueryKey } from "@/features/patient/queries/usePatientDetails";
import type { CcofPatientDetails } from "lib/api-types/schemas";

const MAX_RETRIES = 6;
const RETRY_INTERVAL_MS = 1000;

export function usePollForCard(patientId: string) {
  const { tenantId } = useTenantRouteContext();
  const queryClient = useQueryClient();

  return useCallback(async () => {
    const key = patientDetailsQueryKey(tenantId, patientId);
    for (let i = 0; i < MAX_RETRIES; i++) {
      await new Promise<void>((resolve) =>
        setTimeout(resolve, RETRY_INTERVAL_MS),
      );
      try {
        await queryClient.refetchQueries({ queryKey: key, exact: true });
      } catch {
        // swallow and continue
      }
      const data = queryClient.getQueryData<CcofPatientDetails>(key);
      if (data?.cardOnFile) break;
    }
  }, [tenantId, patientId, queryClient]);
}
